import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { YouWarningIcon } from '../YouWarningIcon/YouWarningIcon';
import {
  ModalContent,
  ModalHeaderImage,
  Title,
  ModalDescription,
  ModalActions,
  OutlinedButton,
  LoadingSpinner,
} from './styles';

export const YouCancelProcessModal = ({
  title,
  description,
  confirmLabel,
  closeModal = undefined,
  onConfirm = undefined,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = useCallback(async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await onConfirm?.();
    } catch {
      /* no-op */
    } finally {
      setSubmitting(false);
      closeModal?.();
    }
  }, [submitting, onConfirm, closeModal]);

  return (
    <ModalContent data-testid="cancel-process-modal">
      <ModalHeaderImage>
        <YouWarningIcon />
      </ModalHeaderImage>

      <Title data-testid="cancel-process-title">{title}</Title>

      <ModalDescription data-testid="cancel-process-description">
        {description}
      </ModalDescription>

      <ModalActions>
        <OutlinedButton
          type="button"
          onClick={handleConfirm}
          disabled={submitting}
          data-testid="cancel-process-confirm"
        >
          {confirmLabel}
          {submitting && <LoadingSpinner size="16px" />}
        </OutlinedButton>
      </ModalActions>
    </ModalContent>
  );
};

YouCancelProcessModal.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  confirmLabel: PropTypes.node.isRequired,
  closeModal: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default YouCancelProcessModal;
